import type { UsageSummaryResponse } from '../types/api'
import { apiClient } from './client'

export async function getUsageSummary(hours = 24): Promise<UsageSummaryResponse> {
  return apiClient.get<UsageSummaryResponse>(`/settings/usage?hours=${hours}`)
}
